// @flow
import React from "react";
import phones from "../../static/images/handsets.png";

import styles from "./appExample.module.scss";

const AppExample = () => (
  <div className={styles.container}>
    <img
      src={phones}
      alt="Just Park example"
      loading="lazy"
      width="3250"
      height="1613"
      className={styles.image}
    />
  </div>
);

export default AppExample;
